module.exports = __webpack_public_path__ + "static/media/keyboard_icon_white1.aafef564.svg";